import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "spring-horizontal-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M2.5 6.5c1.5.5.75 4 2 4s.75-4 2-4 .75 4 2 4 .75-4 2-4 .75 4 2 4 .5-3.5 2-4" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
